/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SecurityWeight } from './SecurityWeight';
import {
    SecurityWeightFromJSON,
    SecurityWeightFromJSONTyped,
    SecurityWeightToJSON,
} from './SecurityWeight';
import type { StrategyWeight } from './StrategyWeight';
import {
    StrategyWeightFromJSON,
    StrategyWeightFromJSONTyped,
    StrategyWeightToJSON,
} from './StrategyWeight';

/**
 * 
 * @export
 * @interface MixedAssetAllocationRequest
 */
export interface MixedAssetAllocationRequest {
    /**
     * 
     * @type {Array<StrategyWeight>}
     * @memberof MixedAssetAllocationRequest
     */
    strategyWeights?: Array<StrategyWeight>;
    /**
     * 
     * @type {Array<SecurityWeight>}
     * @memberof MixedAssetAllocationRequest
     */
    securityWeights?: Array<SecurityWeight>;
}

/**
 * Check if a given object implements the MixedAssetAllocationRequest interface.
 */
export function instanceOfMixedAssetAllocationRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MixedAssetAllocationRequestFromJSON(json: any): MixedAssetAllocationRequest {
    return MixedAssetAllocationRequestFromJSONTyped(json, false);
}

export function MixedAssetAllocationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MixedAssetAllocationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'strategyWeights': !exists(json, 'strategy_weights') ? undefined : ((json['strategy_weights'] as Array<any>).map(StrategyWeightFromJSON)),
        'securityWeights': !exists(json, 'security_weights') ? undefined : ((json['security_weights'] as Array<any>).map(SecurityWeightFromJSON)),
    };
}

export function MixedAssetAllocationRequestToJSON(value?: MixedAssetAllocationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'strategy_weights': value.strategyWeights === undefined ? undefined : ((value.strategyWeights as Array<any>).map(StrategyWeightToJSON)),
        'security_weights': value.securityWeights === undefined ? undefined : ((value.securityWeights as Array<any>).map(SecurityWeightToJSON)),
    };
}

